import {
  ENDPOINT_MERCHANT_AVATAR_UPLOAD,
  ENDPOINT_MERCHANT_SETTINGS_LIST,
  ENDPOINT_MERCHANT_SETTINGS_SET
} from "../../constants/api";

const CancelablePromise = require('mn-utils/CancelablePromise');
const Emitter = require('mn-utils/Emitter');
const {
  DEFAULT_CURRENCY,
} = require('../../constants');
const {
  apiRequest,
} = require('../ws');
const {
  upload,
} = require('../upload');


export const DEFAULT_SETTINGS = {
  fiat: DEFAULT_CURRENCY,
  eth: 1,
  btc: 1,
  ltc: 0,
  dash: 0,
  bth: 0,
  iban: 'iban',
};
export const mockSettings$ = new Emitter(DEFAULT_SETTINGS);

export function apiSettingsSet(params) {
  if (process.env.MOCK) {
    mockSettings$.set(params);
    return CancelablePromise.delay(500, mockSettings$.getValue());
  }
  return apiRequest(ENDPOINT_MERCHANT_SETTINGS_SET, params);
}
export function apiSettingsGet() {
  if (process.env.MOCK) {
    return CancelablePromise.delay(500, mockSettings$.getValue());
  }
  return apiRequest(ENDPOINT_MERCHANT_SETTINGS_LIST);
}

export function apiSettingsSetAvatar(params) {
  const {
    promise,
  } = upload(ENDPOINT_MERCHANT_AVATAR_UPLOAD, params);
  return promise;
}
